import React, { useEffect } from 'react'
import { Button, Card, Col, Container, Row } from 'react-bootstrap'
import { assets } from '../assets/assets'
import { useNavigate, useParams } from 'react-router-dom'
import { Lawndata } from '../data/lawnData'

import "../css/lawn.css"
import Aos from 'aos'
import "aos/dist/aos.css";

export const Lawn = () => {

    let navigate = useNavigate();

    useEffect(() => {
        Aos.init({ duration: 1000 })
    })

    const { id } = useParams();

    const lawn = Lawndata.find((e) => e.id === parseInt(id))

    return (
        <>
            <Container fluid className='lawnpg-container'>

            </Container>

            <Container fluid style={{
                padding: "2rem",

            }}>
                <Row>
                    <Col>
                        <h1 style={{
                            textAlign: "center",
                            padding: "1rem",
                            fontWeight: "700",
                            color: "#850814",
                            fontSize: "2.2rem",
                            letterSpacing: "2px"

                        }}>{lawn.name}</h1>
                    </Col>
                </Row>

                {/* <Row>
                    <Col md={6} style={{
                        marginBottom: "10px"
                    }}>
                        <Card data-aos="fade-up" data-aos-delay="100" style={{
                            padding: "1.5rem",
                            border: "1px solid grey"
                        }}>
                            <Card.Img src={assets.content1}></Card.Img>
                        </Card>
                    </Col>

                    <Col md={6} style={{
                        marginBottom: "10px"
                    }}>
                        <Card data-aos="fade-up" data-aos-delay="100" style={{
                            padding: "1.5rem",
                            border: "1px solid grey"
                        }}>
                            <Card.Img src={assets.content1}></Card.Img>
                        </Card>
                    </Col>

                </Row> */}
            </Container>

            <Container fluid style={{
                padding: "2rem",
            }}>
                <Row>
                    <Col>
                        <h1 style={{
                            textAlign: "center",
                            padding: "1rem",
                            fontWeight: "700",
                            color: "#850814",
                            fontSize: "2.2rem",
                            letterSpacing: "2px"
                        }}>Packages</h1>
                    </Col>
                </Row>

                <Row>

                    <Col md={4} data-aos="fade-up" data-aos-delay="100" style={{
                        marginBottom: "10px"
                    }}>
                        <Card style={{
                            padding: "1rem",
                            // border: "1px solid grey",
                            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)"

                        }}>
                            <Card.Img src={assets.std_pkg} style={{
                                height: "250px",
                                objectFit: "contain",
                                borderBottom: "1px solid #850814"

                            }}></Card.Img>
                            <Card.Body>
                                <Card.Title style={{ color: "#850814" }}>Standard Package</Card.Title>
                                <Card.Text>
                                    <p style={{ fontWeight: "600" }}>Intimate wedding for 500 guests</p>

                                    <li>11 food items served for 500 guests</li>
                                    <li>Elegant main stage decoration & seating for 200 guests</li>
                                    <li>Dressing room & 10 round tables with decor</li>
                                    <li>Service staff & 2 female greeter at the main gate</li>
                                    <li>Instrumental music & electricity backup</li>
                                    <li>Ample Parking with Security</li>
                                </Card.Text>

                                <p style={{ fontWeight: "600" }}>₹1,00,000 Starting Price</p>
                                <Button onClick={() => navigate("/silverpkg")} className='enquire-now-btn'>Enquire Now</Button>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={4} data-aos="fade-up" data-aos-delay="100" style={{
                        marginBottom: "10px"
                    }}>
                        <Card style={{
                            padding: "1rem",
                            // border: "1px solid grey",
                            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)"

                        }}>
                            <Card.Img src={assets.delux_pkg} style={{
                                height: "250px",
                                objectFit: "contain",
                                borderBottom: "1px solid #850814"
                            }}></Card.Img>
                            <Card.Body>
                                <Card.Title style={{ color: "#850814" }}>Delux Package</Card.Title>
                                <Card.Text>
                                    <p style={{ fontWeight: "600" }}>Intimate wedding for 500 guests</p>

                                    <li>14 food items served for 1000 guests</li>
                                    <li>Elegant main stage decoration & seating for 200 guests</li>
                                    <li>Dressing room & 10 round tables with decor</li>
                                    <li>Service staff & 2 female greeters at the main gate</li>
                                    <li>Instrumental music & electricity backup</li>
                                    <li>Ample Parking with Security</li>

                                </Card.Text>

                                <p style={{ fontWeight: "600" }}>₹1,25,000 Starting Price</p>
                                <Button onClick={() => navigate("/goldenpkg")} className='enquire-now-btn'>Enquire Now</Button>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={4} data-aos="fade-up" data-aos-delay="100" style={{
                        marginBottom: "10px"
                    }}>
                        <Card style={{
                            padding: "1rem",
                            // border: "1px solid grey",
                            boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)"
                        }}>
                            <Card.Img src={assets.exec_pkg} style={{
                                height: "250px",
                                objectFit: "contain",
                                borderBottom: "1px solid #850814"
                            }}></Card.Img>
                            <Card.Body>
                                <Card.Title style={{ color: "#850814" }}>Executive Package</Card.Title>
                                <Card.Text>
                                    <p style={{ fontWeight: "600" }}>Intimate wedding for 500 guests</p>

                                    <li>16 food items served for 1000 guests</li>
                                    <li>Elegant main stage decoration & seating for 200 guests</li>
                                    <li>Dressing room & 10 round tables with decor</li>
                                    <li>Service staff & 2 female greeters at the main gate</li>
                                    <li>Instrumental music & electricity backup</li>
                                    <li>Ample Parking with Security</li>

                                </Card.Text>

                                <p style={{ fontWeight: "600" }}>₹1,50,000 Starting Price</p>
                                <Button href="https://wa.me/919923314198" className='enquire-now-btn'>Enquire Now</Button>
                            </Card.Body>
                        </Card>
                    </Col>

                </Row>
            </Container>

            <Container fluid>
                <Row>
                    <Col>
                        <h1 style={{
                            color: "#850814",
                            fontWeight: "700",
                            textAlign: "center",
                            padding: "2rem",
                            letterSpacing: "2px",
                            fontSize: "2.2rem"
                        }}>Contact & Location</h1>
                    </Col>
                </Row>

                <Row>
                    <Col md={6} data-aos="fade-up" data-aos-delay="100" style={{
                        padding: "2rem"
                    }}>
                        <p style={{
                            color: "#850814",
                            fontSize: "1.8rem",
                            fontWeight: "600"
                        }}>Address: </p>

                        <p style={{
                            fontSize: "1.1rem"
                        }}>
                            {lawn.address}
                        </p>

                        <p style={{
                            color: "#850814",
                            fontSize: "1.8rem",
                            fontWeight: "600"
                        }}>Contact: </p>

                        <p style={{
                            fontSize: "1.1rem"
                        }}>9923314198 / 8329775561</p>
                    </Col>

                    <Col md={6} xs={12} data-aos="fade-up" data-aos-delay="100">
                        <iframe src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d119095.92390824732!2d79.05390803726414!3d21.122625681516123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3bd4b96b824d85a1%3A0x76ee2fe591d00076!2sKharbi%20Rd%2C%20New%20Diamond%20Nagar%2C%20Shaktimata%20Nagar%2C%20Kharbi%2C%20Nagpur%2C%20Maharashtra%20440024!3m2!1d21.1226456!2d79.1363097!5e0!3m2!1sen!2sin!4v1760545022955!5m2!1sen!2sin" style={{ border: "0", width: "100%", height: "400px" }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </Col>
                </Row>
            </Container>
        </>
    )
}
